{
  "signInTitle": "Mag-sign in",
  "signInLead": "Mag-sign in para magparehistro sa mga programa, sundan ang mga opisina at subaybayan ang iyong mga ulat.",
  "signUpTitle": "Gumawa ng iyong account",
  "signUpLead": "Isang account para sa iskedyul, programa at rehistro ng bawat opisina.",
  "fullName": "Buong pangalan",
  "passwordHint": "Hindi bababa sa 10 character.",
  "forgot": "Nakalimutan ang password?",
  "noAccount": "Wala pang account?",
  "haveAccount": "May account ka na?",
  "resetTitle": "I-reset ang iyong password",
  "resetLead": "Ilagay ang iyong email at padadalhan ka namin ng link para pumili ng bagong password.",
  "resetSent": "Kung may account ang email na iyon, papunta na ang link. Tingnan ang iyong inbox.",
  "newPassword": "Bagong password",
  "setPassword": "Itakda ang password",
  "passwordChanged": "Napalitan na ang iyong password. Mag-sign in muli.",
  "verifyTitle": "Kinukumpirma ang iyong email…",
  "verified": "Kumpirmado na ang iyong email. Salamat!",
  "verifyBanner": "Pakikumpirma ang iyong email address. Nagpadala kami ng link.",
  "resendVerification": "Ipadala muli ang link",
  "inviteTitle": "I-activate ang iyong staff account",
  "inviteLead": "Inimbitahan ka sa {office} bilang {role}.",
  "activate": "I-activate ang account",
  "guestNote": "Hindi kailangan ng account para mag-ulat ng emergency.",
  "consentSignUp": "Pumapayag ako na itago ng LGU ang mga detalye ng aking account para maibigay ang mga serbisyong ito, ayon sa abiso sa privacy (RA 10173).",
  "showPassword": "Ipakita ang password",
  "hidePassword": "Itago ang password",
  "signingIn": "Nagsa-sign in…",
  "creating": "Ginagawa ang iyong account…",
  "sending": "Ipinapadala…",
  "activating": "Ina-activate…",
  "mobileHint": "Para sa mga paalala sa SMS. Halimbawa: 0917 123 4567",
  "barangayHint": "Uunahin namin ang mga post para sa iyong barangay.",
  "nameRequired": "Ilagay ang iyong buong pangalan.",
  "emailRequired": "Ilagay ang iyong email address.",
  "emailInvalid": "Maglagay ng tamang email address.",
  "passwordRequired": "Ilagay ang iyong password.",
  "passwordShort": "Gumamit ng hindi bababa sa 10 character.",
  "consentRequired": "Pumayag muna sa abiso sa privacy para makapagpatuloy.",
  "staffNote": "Nagtatrabaho sa LGU? Ang mga staff account ay ginagawa sa pamamagitan ng imbitasyon mula sa iyong opisina, hindi rito.",
  "welcomeTitle": "Maligayang pagdating, {name}!",
  "checkEmail": "Nagpadala kami ng link sa {email}. Buksan ito para kumpirmahin ang iyong email address. Puwede mo nang gamitin ang app habang naghihintay.",
  "continue": "Magpatuloy",
  "followSuggestion": "Pumili ng mga opisinang susundan",
  "linkSent": "Nagpadala kami ng bagong link. Tingnan ang iyong inbox.",
  "alreadyVerified": "Kumpirmado na ang iyong email.",
  "sendResetLink": "Ipadala ang reset link",
  "backToSignIn": "Bumalik sa pag-sign in",
  "resetNewLead": "Pumili ng bagong password. Masa-sign out ka sa iba mo pang device.",
  "linkInvalidTitle": "Hindi gumagana ang link na ito",
  "linkMissing": "Kulang ang link. Buksan itong muli mula sa iyong email, o humingi ng bago.",
  "requestNewLink": "Humingi ng bagong link",
  "verifyFailedTitle": "Hindi namin makumpirma ang iyong email",
  "signInToResend": "Mag-sign in para makakuha ng bagong link ng kumpirmasyon.",
  "goToApp": "Pumunta sa app",
  "inviteLeadGeneric": "Inimbitahan ka sa staff workspace ng LGU.",
  "inviteEmail": "Ang iyong staff account",
  "inviteExpiredTitle": "Hindi na magagamit ang imbitasyong ito",
  "inviteMobileHint": "Maaaring gamitin ito ng iyong opisina para makontak ka.",
  "inviteChecking": "Sinusuri ang iyong imbitasyon…"
}
